import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import apartments from './apartments';
import availabilities from './applicantAvailability';
import applications from './applications';
import dialogs from './dialogs';
import lists from './lists';
import showings from './showings';
import tenantProfile from './tenantProfile';
import users from './users';
export default (history: History) => combineReducers({
    router: connectRouter(history),
    form: formReducer,
    users,
    apartments,
    applications,
    dialogs,
    lists,
    showings,
    availabilities,
    tenantProfile
});
